import Logo from "./Logo";

const Header = () => (
  <header className="sticky top-0 z-30 border-b border-border/60 bg-background/85 backdrop-blur supports-[backdrop-filter]:bg-background/70">
    <div className="container flex items-center justify-between px-6 py-4">
      <Logo />
    </div>
  </header>
);

export default Header;
